export default __webpack_public_path__ + "dc3f88cd80cce8bb7d780ba8594e9ee4.svg";